import React from "react";

const BIZ_FIELD_LABELS = [
  { key: "b_no", label: "사업자등록번호" },
  { key: "b_stt", label: "납세자 상태" },
  { key: "b_stt_cd", label: "납세자 상태 코드" },
  { key: "tax_type", label: "과세 유형" },
  { key: "tax_type_cd", label: "과세 유형 코드" },
  { key: "end_dt", label: "폐업일" },
  { key: "utcc_yn", label: "단위과세전환 여부" },
  { key: "tax_type_change_dt", label: "과세유형 전환일" },
  { key: "invoice_apply_dt", label: "세금계산서 적용일" },
  { key: "rbf_tax_type", label: "직전 과세유형" },
  { key: "rbf_tax_type_cd", label: "직전 과세유형 코드" },
];

const formatValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }
  return value;
};

const BizStatusContent = ({
  data,
  bizNo = "",
  isLoading = false,
  isError = false,
  error = null,
}) => {
  if (isLoading) {
    return <p className="px-4 py-3">사업자등록번호 정보를 조회 중입니다.</p>;
  }

  if (isError) {
    return (
      <p className="px-4 py-3 text-[#e80000]">
        사업자등록번호 조회에 실패했습니다.
        {error?.message ? ` (${error.message})` : ""}
      </p>
    );
  }

  if (!data) {
    return <p className="px-4 py-3">조회된 사업자등록번호 정보가 없습니다.</p>;
  }

  const normalizedBizData =
    data?.status_code !== undefined
      ? data
      : data?.data?.status_code !== undefined
      ? data.data
      : data;

  if (normalizedBizData?.status_code !== "OK") {
    return (
      <div className="px-4 py-3 text-[12px]">
        <p className="mb-2">
          <span className="font-bold">사업자등록번호</span> : {bizNo || "-"}
        </p>
        <p className="text-[#e80000]">
          [{normalizedBizData?.status_code || "-"}] 조회 결과를 확인할 수
          없습니다.
        </p>
      </div>
    );
  }

  const bizList = Array.isArray(normalizedBizData?.data)
    ? normalizedBizData.data
    : [];

  return (
    <div className="text-[12px]">
      <div className="mb-3 rounded-[4px] bg-[#f5f5f5] p-3">
        <p>
          <span className="font-bold">요청 건수</span> :{" "}
          {normalizedBizData?.request_cnt ?? "-"}
        </p>
        <p>
          <span className="font-bold">일치 건수</span> :{" "}
          {normalizedBizData?.match_cnt ?? "-"}
        </p>
        <p>
          <span className="font-bold">상태 코드</span> :{" "}
          {normalizedBizData?.status_code || "-"}
        </p>
      </div>

      {bizList.length === 0 ? (
        <p className="px-1 py-2">조회된 사업자 정보가 없습니다.</p>
      ) : (
        <div className="space-y-4">
          {bizList.map((biz, index) => (
            <div
              key={`${biz?.b_no || "biz"}-${index}`}
              className="max-h-[28rem] overflow-auto border border-light-grey rounded-[4px]"
            >
              <table className="w-full text-left text-[11px]">
                <thead className="bg-input-grey">
                  <tr>
                    <th className="border border-light-grey p-2 w-[40%]">
                      항목
                    </th>
                    <th className="border border-light-grey p-2">값</th>
                  </tr>
                </thead>
                <tbody>
                  {BIZ_FIELD_LABELS.map(({ key, label }) => (
                    <tr key={key}>
                      <td className="border border-light-grey p-2 font-medium">
                        {label}
                      </td>
                      <td className="border border-light-grey p-2">
                        {formatValue(biz?.[key])}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BizStatusContent;
